import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: '[appSidebarToggler]'
  })
  export class SidebarToggleDirective {
    constructor() { }
  
    @HostListener('click', ['$event'])
    toggleOpen($event: any) {      
      $event.preventDefault();
      document.querySelector('#sidebar').classList.toggle('active');
    }
  }
  

  



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/sidebar.directive.ts